import { render, staticRenderFns } from "./cate-card.vue?vue&type=template&id=6e8b02e8&"
import script from "./cate-card.vue?vue&type=script&lang=js&"
export * from "./cate-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports